// sudo npm i blurhash@2.0.5

import { Directive, ElementRef, Input, Renderer2, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { encode, decode } from 'blurhash';
import { IFileV2, IFileSysTemFileV2 } from './file-v2.interface';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { URI_APIs } from '@features/auth/const';

@Directive({
  standalone: true,
  selector: '[zaaLoadFileV2]',
})
export class ZaaFileV2LoaderDirective implements OnChanges {
  @Input() zaaLoadFileV2!: IFileV2; // Input to accept the file object
  @Input() noImageURL: string = 'assets/img/logo.png'; // Placeholder for missing images
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private httpClient: HttpClient,
    private readonly conf: CoreAuthConfigService,
  ) {}

  ngOnChanges() {
    if (this.zaaLoadFileV2 != null) {
      this.loadImage(this.zaaLoadFileV2);
    } else {
      this.updateImageSrc(this.noImageURL);
    }
  }

  private loadImage(fileV2: IFileV2) {
    this.updateImageSrc(this.noImageURL);
    const url = this.conf.buildFileV2URL(URI_APIs.GET_LIST); // Make sure to use the correct URL

    this.httpClient
      .post<Array<IFileSysTemFileV2>>(url, {
        list_server_file_name: [fileV2.server_file_name],
      }, {
        headers: {
          use_appkey: "true",
        }
      })
      .subscribe({
        next: (files) => {
          if (files.length > 0) {
            const imageUrl = files[0].url;
            const blurHash = files[0].blur_hash;

            if (blurHash) {
              this.applyBlurHash(blurHash);
            }

            const img = new Image();
            img.src = imageUrl;
            img.onload = () => {
              this.updateImageSrc(imageUrl);
            };
          } else {
            console.error('ZaaFileV2LoaderDirective: No files returned from the server.');
          }
        },
        error: (error) => {
          console.error('ZaaFileV2LoaderDirective: Error fetching image:', error);
        },
      });
  }

  private updateImageSrc(imageUrl: string) {
    // Set the 'src' attribute of the current img element
    this.renderer.setAttribute(this.el.nativeElement, 'src', imageUrl);
    this.renderer.setAttribute(this.el.nativeElement, 'alt', 'Loaded Image');
  }

  private applyBlurHash(blurHash: string) {
    // Decode the blurhash to a pixel array
    const pixels = decode(blurHash, 32, 32); // Width and height for a small preview image
    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;

    const ctx = canvas.getContext('2d');
    if (ctx) {
      const imageData = ctx.createImageData(32, 32);
      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);
      const blurDataUrl = canvas.toDataURL();

      // Set the blurhash preview as the image source while the real image loads
      this.updateImageSrc(blurDataUrl);
    }
  }
}
